'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _BaseField = require('uniforms/BaseField');

var _BaseField2 = _interopRequireDefault(_BaseField);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _nothing = require('uniforms/nothing');

var _nothing2 = _interopRequireDefault(_nothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorsField = function ErrorsField(_ref, _ref2) {
    var _ref2$uniforms = _ref2.uniforms,
        error = _ref2$uniforms.error,
        schema = _ref2$uniforms.schema;
    var className = _ref.className,
        children = _ref.children,
        props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'children']);
    return !error && !children ? _nothing2.default : _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: (0, _classnames2.default)('card card-outline-danger text-danger', className) }, (0, _filterDOMProps2.default)(props)),
        _react2.default.createElement(
            'div',
            { className: 'card-block' },
            children,
            schema.getErrorMessages(error).map(function (message, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index, className: 'disabled' },
                    message
                );
            })
        )
    );
};

ErrorsField.contextTypes = _BaseField2.default.contextTypes;

exports.default = ErrorsField;


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-bootstrap4/ErrorsField.js
// module id = 464
// module chunks = 0